import React from 'react';
import {connect} from 'react-redux';
import exportTemplate from './JobBoardExport.rt';
import * as actions from '../../actions';
import * as popupActions from './../../actions/A_Popups';
import Moment from 'moment';
import _ from 'lodash';

class JobBoardExport extends React.PureComponent{
  constructor() {
    super();
    this.state = {
      email: false,
      download: true,
      emailAddress: "",
      emailMessage: "",
      dateRangeFrom: (new Moment()).add(-7, "days").format("YYYY-MM-DD"),
      dateRangeTo: (new Moment()).format("YYYY-MM-DD"),
      selectedFileName: "",
      excludeDuplicates: false,
      useDateRange: false
    };
  };
  uploadExclusionList = () => {
    let input = document.getElementById('import-exclusion-list');
    if(!_.endsWith(this.state.selectedFileName.toLowerCase(), ".csv")) {
      this.props.messageBox_Show(true, 'error', 'Invalid Exclusion List file type', 'Exclusion list upload must be a CSV file.  Download Exlcusion List for format.');
      return;
    }
    if(input.files && input.files.length > 0) {
      let fileReader = new FileReader();
      fileReader.readAsText(input.files[0]);
      fileReader.onload = (evt) => {
        let contents = evt.target.result;
        this.props.uploadExclusionList(contents)
          .then((e) => {
            this.setState({showUploadNotice: true});
          });
      }
      fileReader.onerror = console.error;
    }
  }
  render = exportTemplate;
}

const mapStateToProps = state => {
  return {

  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    closeJobBoardExport: () => dispatch(popupActions.showJobBoardExport(false)),
    export: (state) => dispatch(actions.jobBoardExport(state)),
    uploadExclusionList: (csv) => dispatch(actions.uploadExclusionList(csv)),
    downloadExclusionList: () => dispatch(actions.downloadExclusionList()),
    messageBox_Show: (show, type, title, msg) => dispatch(popupActions.messageBox_Show(show, type, title, msg))
  };
}

const JobBoardExportContainer = connect(mapStateToProps, mapDispatchToProps)(JobBoardExport);

export default JobBoardExportContainer;
